import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.FirstTimeSetupPage.PendingPracticeInvitationStep', {
    followingBusinessAccountsText: 'You were invited to the following Business Accounts:',
    whatHappenedAfterAcceptingText: `
        After accepting the invitation you’ll have access to the Business Account.
        Your profile data will be visible to the Account Owner and the Managers.`,
    declineAllInvitations: 'Decline all invitations',
});
